// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/federation.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.FederationType
 */
export var FederationType;
(function (FederationType) {
    /**
     * @generated from enum value: UNKNOWN_FEDERATION_PROVIDER = 0;
     */
    FederationType[FederationType["UNKNOWN_FEDERATION_PROVIDER"] = 0] = "UNKNOWN_FEDERATION_PROVIDER";
    /**
     * @generated from enum value: GOOGLE = 1;
     */
    FederationType[FederationType["GOOGLE"] = 1] = "GOOGLE";
    /**
     * @generated from enum value: FACEBOOK = 2;
     */
    FederationType[FederationType["FACEBOOK"] = 2] = "FACEBOOK";
    /**
     * @generated from enum value: APPLE = 3;
     */
    FederationType[FederationType["APPLE"] = 3] = "APPLE";
})(FederationType || (FederationType = {}));
// Retrieve enum metadata with: proto3.getEnumType(FederationType)
proto3.util.setEnumType(FederationType, "no.jotta.openapi.FederationType", [
    { no: 0, name: "UNKNOWN_FEDERATION_PROVIDER" },
    { no: 1, name: "GOOGLE" },
    { no: 2, name: "FACEBOOK" },
    { no: 3, name: "APPLE" },
]);
/**
 * @generated from message no.jotta.openapi.FederationIntent
 */
export class FederationIntent extends Message {
    /**
     * @generated from field: optional string return_url = 10;
     */
    returnUrl;
    /**
     * @generated from oneof no.jotta.openapi.FederationIntent.intent
     */
    intent = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FederationIntent";
    static fields = proto3.util.newFieldList(() => [
        { no: 10, name: "return_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 1, name: "login", kind: "message", T: FederationIntent_Login, oneof: "intent" },
        { no: 2, name: "signup", kind: "message", T: FederationIntent_Signup, oneof: "intent" },
    ]);
    static fromBinary(bytes, options) {
        return new FederationIntent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederationIntent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederationIntent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederationIntent, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FederationIntent.Login
 */
export class FederationIntent_Login extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FederationIntent.Login";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new FederationIntent_Login().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederationIntent_Login().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederationIntent_Login().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederationIntent_Login, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FederationIntent.Signup
 */
export class FederationIntent_Signup extends Message {
    /**
     * @generated from field: optional string product_code = 1;
     */
    productCode;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FederationIntent.Signup";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new FederationIntent_Signup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederationIntent_Signup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederationIntent_Signup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederationIntent_Signup, a, b);
    }
}
